import { render, staticRenderFns } from "./stripped.vue?vue&type=template&id=4c250c04&"
import script from "./stripped.vue?vue&type=script&lang=js&"
export * from "./stripped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports